import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import  './assets/css/global.css';
import './assets/font/CircularStd-Book.woff';
import './assets/font/CircularStd-Book.woff2';
import './assets/font/DJBGetDigital.woff';
import './assets/font/DJBGetDigital.woff2';
import './assets/font/Gothic720BT-RomanB.woff';
import './assets/font/Gothic720BT-RomanB.woff2';
import './assets/font/HelveticaNeueBold.woff';
import './assets/font/HelveticaNeueBold.woff2';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
